import React from 'react'
import Header from '../Components/Header/Header'
import Footer from '../Components/Footer/Footer'
import tr1 from '../assets/trainer/siva.jpg'
import tr2 from '../assets/trainer/Raja.jpg'
import tr3 from '../assets/trainer/rajiv.jpg'
import tr4 from '../assets/trainer/Sateesh.jpg'
import tr5 from '../assets/trainer/sada.jpg'
import tr6 from '../assets/trainer/chaitanya.jpg'
import tr7 from '../assets/trainer/charan.jpg'
import tr8 from '../assets/trainer/ram.jpg'
import arrow from '../assets/arrow-down-right.svg'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { Helmet } from 'react-helmet-async'
library.add(fas, fab)

const Teachers = () => {
  return (
    <div>
        <Helmet>
            <title>Meet Our Expert VLSI Trainers & Faculty Team | Takshila VLSI</title>
            <meta name="description" content="Meet expert VLSI trainers with industry experience in Physical Design, DFT, ASIC Verification, and Analog Layout Design courses at Takshila VLSI." />
            <link rel="canonical" href="https://www.takshila-vlsi.com/teachers/" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="website" />
            <meta property="og:title" content="Meet Our Expert VLSI Trainers & Faculty Team | Takshila VLSI" />
            <meta property="og:description" content="Meet expert VLSI trainers with industry experience in Physical Design, DFT, ASIC Verification, and Analog Layout Design courses at Takshila VLSI." />
            <meta property="og:url" content="https://www.takshila-vlsi.com/teachers/" />
            <meta property="og:site_name" content="Takshila VLSI" />
            <meta name="twitter:card" content="summary_large_image" />
        </Helmet>
        <Header/>
        <main>
            <section className='pg-section p-lg-5'>
                <div class="container">
                          <div class="row justify-content-around text-center">
                              <div class="col-md p-5">
                                    <h2 className='ws-section_heading pd-03'>Our Trainers</h2>
                              </div>
                          </div>
                          <div class="row pb-lg-5">
                            <div class="col-md-4 img-radius pb-4">
                              <a href='/teachers/siva/'>
                              <div className='trainer-box'>
                                <div className='content-box d-flex bg-path'>
                                  <div className='trainer-content'>
                                  <h5 className='trainer-title'>Mr.Siva</h5>
                                  <h6 className='trainer-desig'>Specialist Design For Test (DFT)</h6>
                                  </div>
                                  <div className='trainer-button'><img src={arrow} alt=''/></div>
                                </div>
                                <div className='trainer-img'>
                              <img src={tr1} alt=''/>
                              </div>
                              </div>
                              </a>
                            </div>
                            <div class="col-md-4 img-radius pb-4">
                              <a href='/teachers/raja/'>
                              <div className='trainer-box'>
                                <div className='content-box d-flex bg-path'>
                                  <div className='trainer-content'>
                                  <h5 className='trainer-title'>Mr.Raja</h5>
                                  <h6 className='trainer-desig'>Embedded Systems Specialist </h6>
                                  </div>
                                  <div className='trainer-button'><a href='/teachers/raja/'><img src={arrow} alt=''/></a></div>
                                </div>
                                <div className='trainer-img'>
                              <img src={tr2} alt=''/>
                              </div>
                              </div>
                              </a>
                            </div>
                            <div class="col-md-4 img-radius pb-4">
                              <a href='/teachers/rajiv/'>
                              <div className='trainer-box'>
                                <div className='content-box d-flex bg-path'>
                                  <div className='trainer-content'>
                                  <h5 className='trainer-title'>Mr.Rajiv</h5>
                                  <h6 className='trainer-desig'>ASIC Verification Specialist
                                  </h6>
                                  </div>
                                  <div className='trainer-button'><a href='/teachers/rajiv/'><img src={arrow} alt=''/></a></div>
                                </div>
                                <div className='trainer-img'>
                              <img src={tr3} alt=''/>
                              </div>
                              </div>
                              </a>
                            </div>
                            <div class="col-md-4 img-radius pb-4">
                              <a href='/teachers/sateesh/'>
                              <div className='trainer-box'>
                                <div className='content-box d-flex bg-path'>
                                  <div className='trainer-content'>
                                  <h5 className='trainer-title'>Mr.Sateesh</h5>
                                  <h6 className='trainer-desig'>Analog Circuit Design Specialist
                                  </h6>
                                  </div>
                                  <div className='trainer-button'><a href='/teachers/sateesh/'><img src={arrow} alt=''/></a></div>
                                </div>
                                <div className='trainer-img'>
                              <img src={tr4} alt=''/>
                              </div>
                              </div>
                              </a>
                            </div>
                            <div class="col-md-4 img-radius pb-4">
                              <a href='/teachers/sadakshari/'>
                              <div className='trainer-box'>
                                <div className='content-box d-flex bg-path'>
                                  <div className='trainer-content'>
                                  <h5 className='trainer-title'>Mr.Sadakshari</h5>
                                  <h6 className='trainer-desig'>Analog Layout Design
                                  </h6>
                                  </div>
                                  <div className='trainer-button'><a href='/teachers/sadakshari/'><img src={arrow} alt=''/></a></div>
                                </div>
                                <div className='trainer-img'>
                              <img src={tr5} alt=''/>
                              </div>
                              </div>
                              </a>
                            </div>
                            <div class="col-md-4 img-radius pb-4">
                              <a href='/teachers/chaitanya/'>
                              <div className='trainer-box'>
                                <div className='content-box d-flex bg-path'>
                                  <div className='trainer-content'>
                                  <h5 className='trainer-title'>Mr.Chaitanya</h5>
                                  <h6 className='trainer-desig'>Specialist Physical Design
                                  </h6>
                                  </div>
                                  <div className='trainer-button'><a href='/teachers/chaitanya/'><img src={arrow} alt=''/></a></div>
                                </div>
                                <div className='trainer-img'>
                              <img src={tr6} alt=''/>
                              </div>
                              </div>
                              </a>
                            </div>
                            <div class="col-md-4 img-radius pb-4">
                              <a href='/teachers/charan/'>
                              <div className='trainer-box'>
                                <div className='content-box d-flex bg-path'>
                                  <div className='trainer-content'>
                                  <h5 className='trainer-title'>Mr.Charan</h5>
                                  <h6 className='trainer-desig'>RTL Coding and FPGA Specialist
                                  </h6>
                                  </div>
                                  <div className='trainer-button'><a href='/teachers/charan/'><img src={arrow} alt=''/></a></div>
                                </div>
                                <div className='trainer-img'>
                              <img src={tr7} alt=''/>
                              </div>
                              </div>
                              </a>
                            </div>
                            <div class="col-md-4 img-radius pb-4">
                              <a href='/teachers/ram/'>
                              <div className='trainer-box'>
                                <div className='content-box d-flex bg-path'>
                                  <div className='trainer-content'>
                                  <h5 className='trainer-title'>Mr.Ram</h5>
                                  <h6 className='trainer-desig'>Analog Layout Design Expert
                                  </h6>
                                  </div>
                                  <div className='trainer-button'><a href='/teachers/ram/'><img src={arrow} alt=''/></a></div>
                                </div>
                                <div className='trainer-img'>
                              <img src={tr8} alt=''/>
                              </div>
                              </div>
                              </a>
                            </div>
                          </div>
                          
              </div>
          </section>
                
        </main>
        <Footer/>
    </div>
  )
}

export default Teachers